<app-custom-table
  class="side-scroll-table"
  data-cy="availability-calendar-table">
  <app-custom-date-table-header
    [calendarTableHelper]="calendarTableHelper"></app-custom-date-table-header>

  <div class="custom-table-row">
    {{
      isDispoEditingPooler
        ? ("availabilities" | i18n) || "Verfügbarkeiten"
        : ("myAvailabilities" | i18n) || "Meine Verfügbarkeiten"
    }}
  </div>
  <app-custom-table-row
    class="table-row availability-edit-user-table-row"
    *ngIf="listPreparedUser">
    <app-custom-table-cell
      class="table-cell main-label-cell sticky-main-cell-left"
      data-cy="user-availabilities">
      <div class="name">
        {{ formatUserName(listPreparedUser) }}
      </div>
      <div class="counts">
        <div class="count">
          <div class="number">
            {{ listPreparedUser.totalWorkingCount }}
          </div>
          <div
            class="color-indicator"
            matTooltipPosition="above"
            matTooltipShowDelay="350"
            [matTooltip]="('booked' | i18n) || 'gebucht'">
            <div class="circle circle-yellow"></div>
          </div>
        </div>
        <div class="count">
          <div class="number">
            {{ listPreparedUser.totalDepartmentAvailableCount }}
          </div>
          <div
            class="color-indicator"
            matTooltipPosition="above"
            matTooltipShowDelay="350"
            [matTooltip]="('available' | i18n) || 'verfügbar'">
            <div class="circle circle-green"></div>
          </div>
        </div>
      </div>
    </app-custom-table-cell>
    <app-custom-table-cell
      *ngFor="
        let availability of listPreparedUser?.availabilities;
        let dayIndex = index
      "
      class="table-cell shifts-grid"
      [class.weekday-saturday]="(availability.date | date: 'cc') === '6'"
      [class.weekday-sunday]="(availability.date | date: 'cc') === '0'"
      [class.first-day-of-month]="(availability.date | date: 'd') === '1'"
      [class.last-day-of-month]="availability.date | lastOfMonth"
      [attr.data-cy]="'calendar-day-shifts-grid'"
      (click)="availabilitySelected(availability)">
      <ng-container *ngIf="availability.shifts">
        <div
          *ngIf="availability.shifts[shiftEnum.EARLY]"
          class="shift-badge early-shift"
          [class.working]="availability.shifts[shiftEnum.EARLY] === 'WORKING'"
          [class.unavailable]="
            availability.shifts[shiftEnum.EARLY] === 'UNAVAILABLE'
          "
          [attr.data-cy]="
            'user-early-shift-' +
            availability.shifts[shiftEnum.EARLY]?.toLocaleLowerCase()
          ">
          F
        </div>
        <div
          *ngIf="availability.shifts[shiftEnum.DAY]"
          class="shift-badge day-shift"
          [class.working]="availability.shifts[shiftEnum.DAY] === 'WORKING'"
          [class.unavailable]="
            availability.shifts[shiftEnum.DAY] === 'UNAVAILABLE'
          "
          [attr.data-cy]="
            'user-day-shift-' +
            availability.shifts[shiftEnum.DAY]?.toLocaleLowerCase()
          ">
          M
        </div>
        <div
          *ngIf="availability.shifts[shiftEnum.LATE]"
          class="shift-badge late-shift"
          [class.working]="availability.shifts[shiftEnum.LATE] === 'WORKING'"
          [class.unavailable]="
            availability.shifts[shiftEnum.LATE] === 'UNAVAILABLE'
          "
          [attr.data-cy]="
            'user-late-shift-' +
            availability.shifts[shiftEnum.LATE]?.toLocaleLowerCase()
          ">
          S
        </div>
        <div
          *ngIf="availability.shifts[shiftEnum.NIGHT]"
          class="shift-badge night-shift"
          [class.working]="availability.shifts[shiftEnum.NIGHT] === 'WORKING'"
          [class.unavailable]="
            availability.shifts[shiftEnum.NIGHT] === 'UNAVAILABLE'
          "
          [attr.data-cy]="
            'user-night-shift-' +
            availability.shifts[shiftEnum.NIGHT]?.toLocaleLowerCase()
          ">
          N
        </div>
      </ng-container>
    </app-custom-table-cell>
  </app-custom-table-row>
  <div class="custom-table-row">
    {{
      isDispoEditingPooler
        ? ("departments" | i18n) || "Abteilungen"
        : ("myDepartments" | i18n) || "Meine Abteilungen"
    }}
  </div>
  <ng-container
    *ngFor="
      let departmentAvailability of departmentAvailabilities;
      let i = index
    ">
    <app-custom-table-row
      class="table-row table-department-row"
      *ngIf="i < displayListItemsCount">
      <app-custom-table-cell
        class="table-cell main-label-cell sticky-main-cell-left">
        <div class="name">
          {{ departmentAvailability.department.name }}
        </div>
      </app-custom-table-cell>
      <app-custom-table-cell
        *ngFor="
          let availability of departmentAvailability.availabilities;
          let dayIndex = index
        "
        class="table-cell shifts-grid department-shifts-grid"
        [class.weekday-saturday]="(availability.date | date: 'cc') === '6'"
        [class.weekday-sunday]="(availability.date | date: 'cc') === '0'"
        [class.first-day-of-month]="(availability.date | date: 'd') === '1'"
        [class.last-day-of-month]="availability.date | lastOfMonth"
        [attr.data-cy]="
          'department-row-' + departmentAvailability.department.id
        ">
        <ng-container *ngIf="availability.shifts">
          <div
            *ngIf="
              availability.shifts[shiftEnum.EARLY] !== undefined &&
              availability.shifts[shiftEnum.EARLY] > 0
            "
            class="shift-badge early-shift"
            [class.disabled]="
              !listPreparedUser?.availabilities?.[dayIndex]?.shifts ||
              listPreparedUser?.availabilities?.[dayIndex]?.shifts?.[
                shiftEnum.EARLY
              ] !== 'AVAILABLE'
            "
            [matTooltip]="
              'otherEmployeesAvailable'
                | i18n
                  : {
                      date: (availability.date | date: 'dd.MM.yyyy'),
                      shiftLabel:
                        ('shifts.' + shiftEnum.EARLY.toString() | i18n),
                      count: availability.shifts[shiftEnum.EARLY]
                    }
            "
            matTooltipPosition="above"
            [attr.data-cy]="'department-early-shift'">
            {{ availability.shifts[shiftEnum.EARLY] }}
          </div>
          <div
            *ngIf="
              availability.shifts[shiftEnum.DAY] !== undefined &&
              availability.shifts[shiftEnum.DAY] > 0
            "
            class="shift-badge day-shift"
            [class.disabled]="
              !listPreparedUser?.availabilities?.[dayIndex]?.shifts ||
              listPreparedUser?.availabilities?.[dayIndex]?.shifts?.[
                shiftEnum.DAY
              ] !== 'AVAILABLE'
            "
            [matTooltip]="
              'otherEmployeesAvailable'
                | i18n
                  : {
                      date: (availability.date | date: 'dd.MM.yyyy'),
                      shiftLabel: ('shifts.' + shiftEnum.DAY.toString() | i18n),
                      count: availability.shifts[shiftEnum.DAY]
                    }
            "
            matTooltipPosition="above"
            [attr.data-cy]="'department-day-shift'">
            {{ availability.shifts[shiftEnum.DAY] }}
          </div>
          <div
            *ngIf="
              availability.shifts[shiftEnum.LATE] !== undefined &&
              availability.shifts[shiftEnum.LATE] > 0
            "
            class="shift-badge late-shift"
            [class.disabled]="
              !listPreparedUser?.availabilities?.[dayIndex]?.shifts ||
              listPreparedUser?.availabilities?.[dayIndex]?.shifts?.[
                shiftEnum.LATE
              ] !== 'AVAILABLE'
            "
            [matTooltip]="
              'otherEmployeesAvailable'
                | i18n
                  : {
                      date: (availability.date | date: 'dd.MM.yyyy'),
                      shiftLabel:
                        ('shifts.' + shiftEnum.LATE.toString() | i18n),
                      count: availability.shifts[shiftEnum.LATE]
                    }
            "
            matTooltipPosition="above"
            [attr.data-cy]="'department-late-shift'">
            {{ availability.shifts[shiftEnum.LATE] }}
          </div>
          <div
            *ngIf="
              availability.shifts[shiftEnum.NIGHT] !== undefined &&
              availability.shifts[shiftEnum.NIGHT] > 0
            "
            class="shift-badge night-shift"
            [class.disabled]="
              !listPreparedUser?.availabilities?.[dayIndex]?.shifts ||
              listPreparedUser?.availabilities?.[dayIndex]?.shifts?.[
                shiftEnum.NIGHT
              ] !== 'AVAILABLE'
            "
            [matTooltip]="
              'otherEmployeesAvailable'
                | i18n
                  : {
                      date: (availability.date | date: 'dd.MM.yyyy'),
                      shiftLabel:
                        ('shifts.' + shiftEnum.NIGHT.toString() | i18n),
                      count: availability.shifts[shiftEnum.NIGHT]
                    }
            "
            matTooltipPosition="above"
            [attr.data-cy]="'department-night-shift'">
            {{ availability.shifts[shiftEnum.NIGHT] }}
          </div>
        </ng-container>
      </app-custom-table-cell>
    </app-custom-table-row>
  </ng-container>
  <div
    class="load-more-on-visible"
    (appVisible)="displayMoreEntries()"></div>
</app-custom-table>
